export const fallbackLng = "en";
export const languages = [fallbackLng, "ja", "zh", "de"];
export const defaultNS = "index";
export const localeLocaleStorageKey = "locale";

export enum Lng {
  "zh" = "zh",
  "en" = "en",
  "ja" = "ja",
  "de" = "de",
  "hk" = "hk",
  "fr" = "fr",
  "es" = "es",
  "pt" = "pt",
  "it" = "it",
  "id" = "id",
  "ms" = "ms",
  "vi" = "vi",
}

export const LngList = [Lng.zh, Lng.en, Lng.ja, Lng.de];

export const LngMap: Record<string, string> = {
  en: "English",
  ja: "日本語",
  zh: "简体中文",
  de: "Deutsch",
};

export const supportAILngList = [Lng.zh, Lng.en, Lng.ja];

export const resumeLngList = [
  Lng.en,
  Lng.fr,
  Lng.zh,
  Lng.hk,
  Lng.ja,
  Lng.de,
  Lng.es,
  Lng.pt,
  Lng.it,
  Lng.id,
  Lng.ms,
  Lng.vi,
];

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns: [defaultNS, ns],
  };
}

export const ZhMap = {
  [Lng.zh]: "简体中文",
  [Lng.en]: "英语",
  [Lng.ja]: "日语",
  [Lng.de]: "德语",
  [Lng.hk]: "繁体中文",
  [Lng.fr]: "法语",
  [Lng.es]: "西班牙语",
  [Lng.pt]: "葡萄牙语",
  [Lng.it]: "意大利语",
  [Lng.id]: "印尼语",
  [Lng.ms]: "马来语",
  [Lng.vi]: "越南语",
};

export const EnMap = {
  [Lng.zh]: "Simplified Chinese",
  [Lng.en]: "English",
  [Lng.ja]: "Japanese",
  [Lng.de]: "German",
  [Lng.hk]: "Traditional Chinese",
  [Lng.fr]: "French",
  [Lng.es]: "Spanish",
  [Lng.pt]: "Portuguese",
  [Lng.it]: "Italian",
  [Lng.id]: "Indonesian",
  [Lng.ms]: "Malay",
  [Lng.vi]: "Vietnamese",
};

export function getLngMapBySpecial(lng: Lng) {
  if (lng === Lng.zh) {
    return ZhMap;
  }
  return EnMap;
}

export function getAILng(lng: Lng) {
  if (lng === Lng.hk) {
    return Lng.zh;
  }
  if (supportAILngList.includes(lng)) {
    return lng;
  }
  return Lng.en;
}
